// extracted by mini-css-extract-plugin
module.exports = {"contentMain":"PrivacyStatement_contentMain__30DyD","privacyStatementContent":"PrivacyStatement_privacyStatementContent__2QnfP"};